/* NPM */
import cx from "classnames";
/* UTILS */
import cardData from "./cardData";
import { COMPOUND } from "components/ClinicCheckout/constants";
import { useCompoundEligibility } from "utils/useCompoundEligibility";
/* STYLES */
import styles from "./styles.module.scss";

const Cards = ({ selectedTreatment, setSelectedTreatment }) => {
  const { compoundEligible, compoundCheckoutDisabled } =
    useCompoundEligibility();
  let cards = cardData;

  if (!compoundEligible || compoundCheckoutDisabled) {
    cards = cardData.filter(card => card.type !== COMPOUND);
  }

  const onSelection = treatment => {
    setSelectedTreatment(treatment);
  };

  return cards.map((card, i) => {
    const { type, pill, title, subtitle, text, image, imageAlt } = card;

    return (
      <div
        key={i}
        className={cx(styles.card, {
          [styles.selected]: selectedTreatment === type
        })}
        onClick={() => onSelection(type)}
        data-testid={`card-${type}`}
      >
        <div className={styles.texts}>
          {pill && <div className={styles.pill}>{pill}</div>}
          <h3 className={styles.title}>{title}</h3>
          <h4 className={styles.subtitle}>{subtitle}</h4>
          {text && <p className={styles.text}>{text}</p>}
        </div>

        <div className={styles.imageContainer}>
          <img src={image} alt={imageAlt} />
        </div>
      </div>
    );
  });
};

export default Cards;
